import React from 'react';
import PropTypes from 'prop-types';
import { usePathname } from 'next/navigation';
import Image from '@nerdwallet/react-image';
import { Text } from '@nerdwallet/currency';
import { Auth0Buttons } from '../auth0-buttons/auth0-buttons';
import styles from './login.module.scss';

const Login = ({
  onSuccess,
  isSignedIn,
  loginPageCopyOverride,
  loginTrkLocation,
  loginTrkFormat,
}) => {
  const pathname = usePathname();
  const pageUrl = `${process.env.SITE_BASE_URL}/${pathname}`;

  return (
    <div className={styles.login__cont}>
      <Image
        className={styles.login__img}
        src="https://www.nerdwallet.com/cdn/brand-site/NW_logo_vert.png"
        alt="NerdWallet Brand"
        backgroundColor="transparent"
        naturalHeight={318}
        naturalWidth={289}
      />
      <Text size="large">
        {loginPageCopyOverride ||
          'You must be signed in with the appropriate credentials to view this page'}
      </Text>
      {!isSignedIn ? (
        <div className={styles.login__btn}>
          <Auth0Buttons.Container
            loginTrkLocation={loginTrkLocation}
            loginTrkFormat={loginTrkFormat}
          >
            <Auth0Buttons.GenericButton
              redirectTo={onSuccess || pageUrl}
              customCtaText="SIGN IN OR CREATE ACCOUNT"
            />
          </Auth0Buttons.Container>
        </div>
      ) : null}
    </div>
  );
};

Login.displayName = 'Login';

Login.propTypes = {
  onSuccess: PropTypes.string,
  isSignedIn: PropTypes.bool,
  loginPageCopyOverride: PropTypes.string,
  loginTrkLocation: PropTypes.string,
  loginTrkFormat: PropTypes.string,
};

export default Login;
